import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./CreateOrder.module.scss";
import commonStyle from "../common.module.scss";
import { numberToFinanceFormat } from "../../../../utils";
import InfoIcon from "../../../shared/icons/InfoIcon";
import CustomInput from "../../../custom/custom-input/CustomInput";
import CargoInsurance from "../../cargo-insurance/CargoInsurance";
import ToggleSwitchIcon from "../../../shared/icons/ToggleSwitchIcon";
import OrderCustomInput from "../../../CreateOrder/Input/OrderCustomInput";
import AccessDeniedModal from "../../../shared/SubscriptionModal/AccessDeniedModal";
import { t } from "i18next"

const OrdersSectionItemPaymentExpeditor = ({
   title,
   withInsurance = false,
   priceDiscount = 0,
   price = '',
   changeInput,
   defaultCount,
   onPriceChange,
   algoPrice,
   errorText = "",
   queryInsurance,
   declaredPrice,
   calcInsurance,
   fileInvoice,
   setInvoiceFile,
   saveDraft,
   isPublic,
   setIsPublic,
   errorsIsPublic = "",
   companyName = "Свой автопарк",
   user,
}) => {
  const [count, setCount] = useState(defaultCount);
  const [isDisplayModal, changeDisplayModal] = useState(false)

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  useEffect(() => {
    if (count !== defaultCount && changeInput) {
      changeInput(count);
    }
  }, [count]);

  const handleToggleMarket = () => {
    if (user && user.permissions?.includes("restricted_view")) {
      changeDisplayModal(true);
      return;
    }

    if (isPublic === true) {
      setIsPublic(null);
    } else {
      setIsPublic(true);
    }
  };

  const handleToggleAutopack = () => {
    if (user && user.permissions?.includes("restricted_view")) {
      changeDisplayModal(true);
      return;
    }

    if (isPublic === false) {
      setIsPublic(null);
    } else {
      setIsPublic(false);
    }
  };

  const totalPrice = () => {
    const priceValue = price === '' ? 0 : Number(price);
    const discountValue = priceDiscount === '' ? 0 : Number(priceDiscount);
    return priceValue + discountValue;
  };

  return (
      <>
        <div className={commonStyle.createOrderContainer}>
          {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

          <div className={commonStyle.createOrderContainer_price}>
            <div className={commonStyle.algo}>
              <InfoIcon width="20px" height="20px" />

              {algoPrice ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(algoPrice)} ₸
                </span>
                    <span className={commonStyle.typography_regular}>{title}</span>
                  </div>
              ) : (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className={commonStyle.typography_large}>{t('priceUndefined')}</span>
                    <span
                        className={commonStyle.typography_regular}
                        style={{ color: "#FF8502" }}
                    >
                  {t('fillAllFieldsToCalc')}
                </span>
                  </div>
              )}
            </div>
            <div style={{ flex: "1" }}>
              <CustomInput
                  labelText={t('cargoTransportationPrice')}
                  placeholder={t('addYourSum')}
                  errorText={errorText}
                  isBgGray={true}
                  prefixEnd={<span>〒</span>}
                  inputType="text"
                  value={price || ''}
                  onChangeValue={(item) => {
                    const numericValue = item.replace(/\D/g, '');
                    if (numericValue !== '0') {
                      onPriceChange(numericValue);
                    } else if (numericValue === '' || numericValue === null) {
                      onPriceChange('');
                    }
                  }}
              />
            </div>
          </div>

          <div className={cn(commonStyle.checkbox_wrapper)}>
            <div className={commonStyle.checkbox_content}>
              <p>{t('orderDuplicate')}</p>
              <span>{t('orderDuplicateQuantity')}</span>
            </div>
            <div className={styles["createOrder__amount-count"]}>
              <button
                  className={styles["createOrder__amount-button"]}
                  onClick={decrementCount}
              >
                -
              </button>
              <OrderCustomInput
                  value={count}
                  onChange={(e) => setCount(parseInt(e.target.value) || 1)}
              />
              <button
                  className={styles["createOrder__amount-button"]}
                  onClick={incrementCount}
              >
                +
              </button>
            </div>
          </div>

          <CargoInsurance
              defaultValue={withInsurance}
              onClick={queryInsurance}
              declaredPrice={declaredPrice}
              setDeclaredPrice={calcInsurance}
              fileInvoice={fileInvoice}
              setInvoiceFile={setInvoiceFile}
              detect={saveDraft}
          />

          <div className={cn(commonStyle.checkbox_wrapper, {
            [commonStyle.checkbox_errorState]: errorsIsPublic,
          })}>
            <div className={commonStyle.checkbox_content}>
              <p>{t("orderInfo.executor")} binY</p>
              <span>{t("binyExecutor")}</span>
            </div>
            <div className={cn(commonStyle.checkbox_switch)} onClick={handleToggleMarket}>
              {isPublic === true  ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
            </div>
          </div>

          <div className={cn(commonStyle.checkbox_wrapper, {
            [commonStyle.checkbox_errorState]: errorsIsPublic,
          })}>
            <div className={commonStyle.checkbox_content}>
              <p>{t("orderInfo.executor")} {companyName}</p>
              <span>{t("companyExecutor")}</span>
            </div>
            <div className={cn(commonStyle.checkbox_switch)} onClick={handleToggleAutopack}>
              {isPublic === false ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
            </div>
          </div>

          {errorsIsPublic &&
              <span style={{color:"#C84620"}}>{errorsIsPublic}</span>
          }

          <div className={commonStyle.all_price}>
            <div className={commonStyle.cargo}>
              <span className={commonStyle.typography_small}>{t('transportationPrice')}</span>
              <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
                {price === '' ? 0 : price} 〒
              </div>
            </div>
            <div className={commonStyle.cargo}>
              <span className={commonStyle.typography_small}>{t('cargoInsurancePrice')}</span>
              <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
                {priceDiscount} 〒
              </div>
            </div>
            <div className={commonStyle.cargo}>
              <span className={commonStyle.typography_medium}>{t('totalPrice')}</span>
              <div className={cn(commonStyle.cargo_price, commonStyle.typography_medium)}>
                {totalPrice()} 〒
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default OrdersSectionItemPaymentExpeditor;